import actions from "./action";

const initState = {
  buttonLoading: false,
  error: null,
  messages: null,
   loading: false,
  aiCredentials: [],
  aiCredentialError: null,
};

export default function userLoginReducer(state = initState, action) {
  switch (action.type) {
    case actions.CREATE_USER_LOGIN:
      return {
        ...state,
        buttonLoading: true,
        error: null,
      };

    case actions.CREATE_USER_LOGIN_SUCCESS:
      return {
        ...state,
        buttonLoading: false,
        messages: action.payload.message,
        error: null,
      };

    case actions.CREATE_USER_LOGIN_FAILED:
      return {
        ...state,
        buttonLoading: false,
        error: action.payload.error,
      };

    case actions.CLEAR_USER_LOGIN_MESSAGES:
      return {
        ...state,
        error: null,
        messages: null,
      };

      case actions.GET_AllAICREDENTIAL_DATA:
      return {
        ...state,
        loading: true,
        aiCredentialError: null,
      };

    case actions.GET_AllAICREDENTIAL_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        aiCredentials: action.payload.data,
        aiCredentialError: null,
      };

    case actions.GET_ALLAICREDENTIAL_DATA_FAILED:
      return {
        ...state,
        loading: false,
        aiCredentialError: action.payload.error,
      };

      case actions.UPDATE_AI_DETAILS:
  return {
    ...state,
    buttonLoading: true,
    error: null,
  };

case actions.UPDATE_AI_DETAILS_SUCCESS:
  return {
    ...state,
    buttonLoading: false,
    messages: action.payload.message,
    error: null,
  };

case actions.UPDATE_AI_DETAILS_FAILED:
  return {
    ...state,
    buttonLoading: false,
    error: action.payload.error,
  };



    default:
      return state;
  }
}

